import { isSupportedAssociation } from './isSupportedAssociation';
import { associationDefinitionToId } from './associationDefinitionToId';

// These associations are the arbitrary associations supported on the index
// page. This is a temporary list and should only be used to coordinate the
// associations supported for displaying on the index page or when exporting
// "all" properties. Long term, this arbitrary list should be replaced by
// supporting all associations (or using metadata on the association to
// filter).
export const getSupportedAssociationsByObjectType = (objectTypeId, associationDefinitions, args) => {
  return Object.values(associationDefinitions).filter(def => def !== undefined).filter(def => def.fromObjectTypeDefinition.objectTypeId === objectTypeId).filter(def => isSupportedAssociation(def, args)).map(def => associationDefinitionToId(def));
};